<template>
  <div>
    <div
      class="friend-link-container"
      @mouseenter="handleShowOperationBtn(props.showEditContentButton)"
      @mouseleave="handleShowOperationBtn(false)"
    >
      <a
        v-for="item in configDataForm"
        :key="item.siteId"
        :href="item.siteUrl"
        target="_blank"
        >{{ item.siteName }}</a
      >
      <operation-container
        v-if="showOperationBtn && !showEditForm"
        :component-data="props.componentData"
        :show-edit-content-button="props.showEditContentButton"
        :show-edit-components-button="props.showEditComponentsButton"
        :show-delete-components-button="props.showDeleteComponentsButton"
        :show-insert-components-button="props.showInsertComponentsButton"
        :show-sort-components-button="props.showSortComponentsButton"
        @handle-show-edit-form="handleShowEditForm"
        @handle-change-components="handleChangeComponents"
        @handle-delete-components="handleDeleteComponents"
        @handle-insert-components="handleInsertComponents"
        @handle-sort-components="handleSortComponents"
      ></operation-container>
    </div>
    <el-drawer
      v-if="showEditForm"
      v-model="showEditForm"
      size="60%"
      :title="props.componentData.componentName"
    >
      <friend-link-edit-form
        v-if="showEditForm"
        v-model="configDataForm"
        :component-data="props.componentData"
        @handle-edit-components-content="handleEditComponentsContent"
        @handle-show-edit-form="handleShowEditForm"
      ></friend-link-edit-form>
    </el-drawer>
  </div>
</template>
<script setup>
// #region 引用
import OperationContainer from '../common/OperationContainer.vue';
import FriendLinkEditForm from './FriendLinkEditFormThree.vue';
// #endregion

// #region props/emit
/**
 * 属性
 */
const props = defineProps({
  showEditContentButton: {
    type: Boolean,
    default: true,
  },
  showEditComponentsButton: {
    type: Boolean,
    default: false,
  },
  showDeleteComponentsButton: {
    type: Boolean,
    default: false,
  },
  showInsertComponentsButton: {
    type: Boolean,
    default: false,
  },
  showSortComponentsButton: {
    type: Boolean,
    default: false,
  },
  componentData: {
    type: Object,
    default() {},
  },
});
// console.log('props-configDataForm-FriendLinkThree:', props);

/**
 * 方法
 */
const emits = defineEmits([
  'handle-show-edit-form',
  'handle-change-components',
  'handle-delete-components',
  'handle-insert-components',
  'handle-sort-components',
  'handle-edit-components-content',
  'update:modelValue',
]);

// #endregion

// #region 变量/常量
// 处理图片未上传的情况
// 预加载所有图片（构建时生成映射）
const images = import.meta.glob('@/assets/images/web/common/other/*.png', {
  eager: true,
 query: '?url',
});
// 直接获取目标图片 URL
const noUpload = images['/src/assets/images/web/common/other/no-upload.png']?.default;

const configDataForm = ref([
  {
    sortNum: 1,
    siteName: '天府老年大学',
    siteUrl: 'http://www.tfu3a.com/',
  },
  {
    sortNum: 2,
    siteName: '多米岛',
    siteUrl: 'http://www.dormistore.com/',
  },
  {
    sortNum: 3,
    siteName: '康养护理学院',
    siteUrl: 'https://kyhl.tfswufe.edu.cn/',
  },
  {
    sortNum: 4,
    siteName: '乐力',
    siteUrl: 'https://www.leliwell.com/',
  },
]);

// 表单绑定对象

if (props.componentData.configData) {
  configDataForm.value = JSON.parse(props.componentData.configData);
  configDataForm.value.sort((a, b) => {
    return a.sortNum - b.sortNum;
  });
}

// 操作显示按钮控制
const showOperationBtn = ref(false);
// 显示编辑表单
const showEditForm = ref(false);

// #endregion

// #region 生命周期

// #endregion

// #region 业务方法
/**
 * 显示
 */
const handleShowOperationBtn = (flag) => {
  showOperationBtn.value = flag;
};
/**
 * 显示编辑表单
 */
const handleShowEditForm = (flag) => {
  showEditForm.value = flag;
};
/**
 * 处理编辑表单内容
 */
const handleEditComponentsContent = (flag) => {
  // console.log('configDataForm-FriendLinkThree--1:', configDataForm);
  // 待数据更新完成后才执行
  nextTick(() => {
    emits('update:modelValue', configDataForm.value);
    emits('handle-edit-components-content', true);
  });

  handleShowEditForm(flag);
};

/**
 * 改变组件
 */
const handleChangeComponents = () => {
  emits('handle-change-components', true);
};

/**
 * 删除组件
 */
const handleDeleteComponents = () => {
  emits('handle-delete-components', true);
};

/**
 * 插入组件
 */
const handleInsertComponents = () => {
  emits('handle-insert-components');
};
/**
 * 组件排序
 */
const handleSortComponents = (moveObj) => {
  emits('handle-sort-components', moveObj);
};

// #endregion
</script>
<style scoped lang="scss">
@import '@/styles/website/_variables.scss';

/* PC端样式 */
@include pc {
  .friend-link-container {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin: 20px 0;
  }

  .friend-link-container a {
    height: 20px;
    padding: 20px 0;
    margin: 20px;
    font-size: 16px;
    transition: color $website-duration-fast $website-ease-out;

    &:hover {
      color: $website-primary;
    }
  }
}

/* 移动端样式 */
@include mobile {
  .friend-link-container {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin: 3vw 0;
    padding: 0 4vw;
  }

  .friend-link-container a {
    height: auto;
    padding: 2vw 0;
    margin: 2vw 3vw;
    font-size: 3.5vw;
    transition: color $website-duration-fast $website-ease-out;

    &:active {
      color: $website-primary;
    }
  }
}
</style>
